import { CurrencyType } from '@soposopo/sopo-models';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavController } from '@ionic/angular';
import { SopoTransitionService } from '../../services/sopo-transition/sopo-transition.service';
import { FeatureService } from 'src/app/core/firebase/feature.service';
import { NavigationExtras } from '@angular/router';
import { AuthStoreDispatcher } from 'src/app/core/state/auth/auth.dispatcher';
import { SopoPopupService } from 'src/app/sopo-popup/service/sopo-popup.service';
import { SopoConfirmSettings } from 'src/app/sopo-popup/interfaces/confirm';
import { FreePlayLobbyService } from 'src/app/core/firebase/free-play.service';

@Component({
    selector: 'app-title-bar',
    templateUrl: './title-bar.component.html',
    styleUrls: ['./title-bar.component.scss'],
    standalone: false
})
export class TitleBarComponent implements OnInit {
    @Output() backNavigation: EventEmitter<boolean> = new EventEmitter();
    @Input() lineColor: string = '#4866A5';
    @Input() gradientStartColor: string = '#040D24';
    @Input() gradientEndColor: string = '#071644';
    @Input() title: string;
    @Input() smallFontSize: boolean = false;
    @Input() verticalGradient: boolean = false;
    @Input() additionalTitleStyle: {} = {};
    @Input() blackPattern: boolean = false;
    @Input() sweepstakes: boolean = false;
    @Input() freeplay: boolean = false;
    @Input() social: boolean = false;
    @Input() clubList: boolean = false;
    @Input() uppercase: boolean = false;
    @Input() image: string;
    @Input() backLink: string;
    @Input() tutorial: string;
    @Input() withoutLine: boolean = false;
    @Input() pointedFrame: boolean = true;
    @Input() goldJackpot: boolean;
    @Input() clubLobby: boolean = false;
    @Input() sweepsWaitingJackpot: boolean = false;
    isSweepBuckOn: boolean = false;
    isTutorialEnabled: boolean = false;

    constructor(
        private navControl: NavController,
        private sopoTransitionService: SopoTransitionService,
        private featureService: FeatureService,
        private sopoPopupService: SopoPopupService,
        private authDispatcher: AuthStoreDispatcher,
        private freeplayService: FreePlayLobbyService,
    ) { }

    ngOnInit() { 
        this.isSweepBuckOn = this.featureService.sweepbucks;
    }

    getBackgroundGradient() {
        if (this.blackPattern || this.sweepstakes || this.social) return '';
        const gradientDegree = !this.verticalGradient ? '90deg,' : '';
        return `linear-gradient(${gradientDegree} ${this.gradientStartColor} 0%, ${this.gradientEndColor} 100%)`;
    }

    async navigateToBack(link: string) {
        let navigationExtras: NavigationExtras = {};
        if (link === '/' || link === '/lobby/home/sweepstakes-from-leaderboards') {
            this.backNavigation.emit();
            return;
        }
        if (this.clubLobby) {
            navigationExtras = { queryParams: { openClubList: true } };
        }
        if (link === "/lobby/home") {
            await this.sopoTransitionService.openTransition();
        }
        if (link === "/lobby/home/sweepstakes") {
            const confirmation = await this.freeplayService.navigateAwayFromJackpotQueue();
            if(!confirmation) {
                return;
            }
            navigationExtras = {
                queryParams: {
                    tabs: this.freeplay ? 'freeplay' : 'sweepstakes',
                    gameTab: "SNG",
                },
            }
        }
        this.navControl.navigateRoot(link, navigationExtras);
    }

}
